import React from 'react';
import { Col, Nav, NavItem, Row, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import * as permissions from '../constants/permissions';
import Create from '../components/orders/Create';
import {
    clearUpdateOrder as clearUpdateOrderAction,
    createOrder as createOrderAction,
    clearOrders as clearOrdersAction
} from '../actions/orders';
import { clear as clearCustomerInfoAction } from '../actions/customers';
import { taxiClasses } from '../constants/taxiClasses';
import { connect } from 'react-redux';
import { states as orderStates, INIT as initState, ON_RECEIVING_POINT as onReceivingPointState, defaultHighlightColor } from '../constants/orderStates'

let Orders = class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showOrderCreate: false
        };
        this._onCreateClick = this._onCreateClick.bind(this);
        this._onCreateClose = this._onCreateClose.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._clearCrudAction = this._clearCrudAction.bind(this);
    }

    _onCreateClick() {
        this.setState({ showOrderCreate: true });
    }
    _onCreateClose() {
        this.setState({ showOrderCreate: false });
        const allOrdersPath = permissions.getRole() == permissions.RECEPTION_POINT ? '/orders/all-on-points' : '/orders/all';
        this.props.history.push(allOrdersPath);
        this._clearCrudAction();
    }
    _onSubmit(value) {
        this.props.createOrderAction(value);
    }
    _clearCrudAction() {
        this.props.clearUpdateOrderAction();
        this.props.clearOrdersAction();
        this.props.clearCustomerInfoAction();
    }

    render() {
        const { isReceptionPoint } = this.props;
        const isAllowedToOrders = permissions.isAllowedFor(permissions.allowedEditOrders);

        const isAllowedForProcessed = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedOrdersInFabric);
        const isAllowedForReceivingPoint = isAllowedToOrders && permissions.isAllowedFor(permissions.allwedOrdersOnReceivingPoint);
        const isAllowedForUrgent = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedOrdersUrgent);
        const isAllowedForDelivery = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedDeliveryOrders);
        const isAllowedForReceptionPointDelivery = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedReceptionPointDelivery);
        const isAllowedForOnFactory = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedOrdersOnFactory);
        const isAllowedForDone = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedDoneOrders);
        const isAllowedForCompleated = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedCompleatedOrders);
        const isAllowedForAll = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedAllOrders);
        const isAllowedForAllOnPoint = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedAllOnPointsOrders);
        const isAllowedForReceptionPointProcessed = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedForReceptionPointProcessed);
        const isAllowedForReceptionPointsOrders = isAllowedToOrders && permissions.isAllowedFor(permissions.allowedForReceptionPointOrders);

        const createEntity = {
            CreatedAt: null,
            Id: 0,
            Items: [],
            OffloadDate: null,
            OffloadTaxiClass: taxiClasses[0],
            Phone: "",
            PickupAddress:
            {
                Address: "",
                City: "",
                District: "",
                Entrance: "",
                Flat: "",
                Floor: "",
                GeoAddress: { X: 0, Y: 0 },
                Id: 0,
                IntercomCode: "",
                IsDeleted: false
                ,
                PickupAddressString: "",
                PickupDate: null,
                State: 0
            },
            PickupTaxiClass: taxiClasses[0],
            State: isReceptionPoint ? orderStates.find(os => os.Id == onReceivingPointState) : orderStates.find(os => os.Id == initState),
            HighlightColor: defaultHighlightColor
        };
        const editModalProps = {
            initialValues: createEntity,
            isNew: true,
            fetching: this.props.createFetching,
            onSubmit: this._onSubmit,
            onClose: this._onCreateClose
        };

        return (
            <div style={{ marginTop: '-15px', marginLeft: '15px', paddingRight: '15px' }}>
                <Row>
                    <Col>
                        <Nav bsStyle="tabs">
                            {isAllowedForReceivingPoint && <LinkContainer to='/orders/on-receiving-point'>
                                <NavItem>Заказы в пункте приема</NavItem>
                            </LinkContainer>}
                            {isAllowedForUrgent && <LinkContainer to='/orders/urgent'>
                                <NavItem>Срочное</NavItem>
                            </LinkContainer>}
                            {isAllowedForDelivery && <LinkContainer to='/orders/delivery'>
                                <NavItem>Доставка(клиенты)</NavItem>
                            </LinkContainer>}
                            {isAllowedForReceptionPointDelivery && <LinkContainer to='/orders/reception-point-delivery'>
                                <NavItem>Доставка(для пп)</NavItem>
                            </LinkContainer>}
                            {isAllowedForReceptionPointProcessed && <LinkContainer to='/orders/reception-point-processed' >
                                <NavItem>Обработан технологом(для пп)</NavItem>
                            </LinkContainer>}
                            {isAllowedForOnFactory && <LinkContainer to='/orders/on-factory'>
                                <NavItem>Заказы на производстве</NavItem>
                            </LinkContainer>}
                            {isAllowedForDone && <LinkContainer to='/orders/done'>
                                <NavItem>Выполненные заказы</NavItem>
                            </LinkContainer>}
                            {isAllowedForCompleated && <LinkContainer to='/orders/compleated'>
                                <NavItem>Выполненные заказы</NavItem>
                            </LinkContainer>}
                            {isAllowedForAll && <LinkContainer to='/orders/all'>
                                <NavItem>Все заказы</NavItem>
                            </LinkContainer>}
                            {isAllowedForAllOnPoint && <LinkContainer to='/orders/all-on-points'>
                                <NavItem>Все заказы</NavItem>
                            </LinkContainer>}
                            {isAllowedForProcessed && <LinkContainer to='/orders/processed'>
                                <NavItem>Прием заказов на фабрике</NavItem>
                            </LinkContainer>}
                            {isAllowedForReceptionPointsOrders && <LinkContainer to='/orders/reception-point-orders'>
                                    <NavItem>Пункт приема</NavItem>
                                </LinkContainer>}
                            {<Button bsStyle='primary' onClick={this._onCreateClick} style={{float: 'right', marginRight: '15px'}}>Создать</Button>}
                        </Nav>
                    </Col>
                </Row>
                {this.state.showOrderCreate && <Create {...editModalProps} />}
            </div>);
    }
}

function mapToProps(state, props) {
    const orders = state.application.get('orders');
    const updateFetching = orders.get('updateFetching');
    const isReceptionPoint = permissions.getRole() == permissions.RECEPTION_POINT;
    return {
        createFetching: updateFetching,
        isReceptionPoint
    }
}

Orders = connect(mapToProps, {
    createOrderAction,
    clearOrdersAction,
    clearUpdateOrderAction,
    clearCustomerInfoAction
})(Orders);

export default Orders;


// WEBPACK FOOTER //
// ./src/containers/Orders.jsx